import React from 'react';
import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux';
import Routes from 'routes';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import { AliveScope } from 'react-activation';

export const Views = () => {
    const {locale, direction} = useSelector(state => state.theme);

    const currentAppLocale = resources[locale];
    useBodyClass(`dir-${direction}`);
    return (
        <AliveScope>
            <ConfigProvider direction={direction} locale={currentAppLocale.antd}>
                <Routes/>
            </ConfigProvider>
        </AliveScope>
    )
}

export default Views;
